import { render, staticRenderFns } from "./rateContent.vue?vue&type=template&id=ef2b2acc&scoped=true"
import script from "./rateContent.vue?vue&type=script&lang=ts"
export * from "./rateContent.vue?vue&type=script&lang=ts"
import style0 from "./rateContent.vue?vue&type=style&index=0&id=ef2b2acc&prod&scoped=true&lang=scss"
import style1 from "./rateContent.vue?vue&type=style&index=1&id=ef2b2acc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2b2acc",
  null
  
)

export default component.exports